import React from 'react';

import Column from '@amzn/meridian/column';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import { type FlatTableDataRow } from 'src/utils/jmrUtils';

interface LeftColumnProps {
  selectedResults: FlatTableDataRow[];
}

const leftColumn = ({ selectedResults }: LeftColumnProps) => {
  return (
    <Column width="200" spacing="none">
      {/* Label */}
      <Row className="new-jmr__placements-table__header-row new-jmr__placements-table__left-col">
        <Text type="h100">Job Name</Text>
      </Row>

      {/* Job Name and Type */}
      {selectedResults?.map((row, index) => (
        <Row
          height={'150px'}
          data-cy={'new-jmr__placements-table__left-col__name-job-type__' + index}
          data-testid="new-jmr__placements-table__left-col"
          className="new-jmr__placements-table__content-row new-jmr__placements-table__left-col"
          spacing="none"
          spacingInset="300"
          overflowY="scroll"
          alignmentVertical="center"
          key={index}
        >
          <Column spacing={'200'} alignmentVertical="center">
            <Text type="h100">{row.name}</Text>
            <Text type="b200" color="secondary">
              {row.shiftCode || '-'}
            </Text>
            <Text type="b200" color="secondary">
              {row.jobType}
            </Text>
          </Column>
        </Row>
      ))}

      {/* Filler */}
      {selectedResults?.length === 0 && (
        <Row className="new-jmr__placements-table__empty-row" widths={['fill']} backgroundColor="highlight"></Row>
      )}

      {/* Hours Label */}
      <Row
        className="new-jmr__placements-table__footer-row new-jmr__placements-table__left-col"
        alignmentVertical="center"
      >
        <Text type="h100">Shift Hours</Text>
      </Row>
    </Column>
  );
};

export default leftColumn;
